import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

/**
 * state maintained on user clicked on
 * 'chat with an agent' button
 * true when starting a conversation and
 * false when conversation is ended
 */
const hasUserInitiatedAuthChatState = atom({
  key: 'hasUserInitiatedAuthChatState',
  default: false,
});

export const useHasUserInitiatedAuthChat = () =>
  useRecoilValue(hasUserInitiatedAuthChatState);

export const useSetHasUserInitiatedAuthChat = () =>
  useSetRecoilState(hasUserInitiatedAuthChatState);
